import { LessonType } from '@/domains';

export const lessonTypeToUrlParam: Record<LessonType, string> = {
  [LessonType.PubliclyAvailable]: 'basic',
  [LessonType.Basic]: 'basic',
  [LessonType.Kriya]: 'kriya',
  [LessonType.Supplement]: 'supplement',
  [LessonType.Advanced]: 'advanced'
};
